var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"screen",staticClass:"screen-controls",on:{"pointerdown":_vm.eventHandler,"pointerup":_vm.eventHandler,"touchend":_vm.eventHandler,"contextmenu":function($event){$event.preventDefault();}}})}
var staticRenderFns = []

export { render, staticRenderFns }